import { COUNTRY_CODES } from "../../constants/countries";

export const MENU_VISIBILITY_BY_COUNTRY = {
    [COUNTRY_CODES.ECUADOR]: {
        hide: [],
    },
    [COUNTRY_CODES.PARAGUAY]: {
        hide: [], // 5.4 Oculta "Abonos"
    },
};